import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Inject,
  Injector,
  NgModule,
  Type,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MODAL_DATA } from '../tokens/modal-data.token';
import { CommonModule } from '@angular/common';

export interface BaseNotificationModalDataOptions {
  showCloseButton?: boolean;
}

export type BaseNotificationModalData<T> = {
  modalComponent: Type<any>;
  data: T & BaseNotificationModalDataOptions;
};

@Component({
  selector: 'lp2-base-notification',
  template: `
    <button *ngIf="showCloseButton" (click)="onClose()" class="close-button"><i class="far fa-times"></i></button>
    <ng-container #modalContainer></ng-container>
  `,
  styles: [
    `
      .notification-modal {
        .modal-dialog {
          max-width: 650px;
        }
        .modal-content {
          border-radius: 24px;
          overflow: hidden;
          border: none;
        }
      }

      .close-button {
        position: absolute;
        top: 24px;
        right: 24px;
        border: none;
        background: none;
        z-index: 1000;
        cursor: pointer;
        border: none;
        outline: none;
        color: white;
        &:focus {
          outline: none;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BaseNotificationModalComponent<T> implements AfterViewInit {
  @ViewChild('modalContainer', { read: ViewContainerRef }) container: ViewContainerRef;
  showCloseButton: boolean;

  constructor(
    @Inject(MODAL_DATA) public readonly data: BaseNotificationModalData<T>,
    private readonly ngbActiveModal: NgbActiveModal,
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  private updateShowCloseButton() {
    let showCloseButton = true;

    if (this.data.data && this.data.data.showCloseButton !== undefined) {
      showCloseButton = this.data.data.showCloseButton;
    } else if (
      ((this.data.data as any) as BaseNotificationModalData<any>).data &&
      ((this.data.data as any) as BaseNotificationModalData<any>).data.showCloseButton !== undefined
    ) {
      showCloseButton = (this.data as BaseNotificationModalData<any>).data.showCloseButton;
    }

    this.showCloseButton = showCloseButton;
    this.changeDetectorRef.detectChanges();
  }

  public ngAfterViewInit() {
    this.projectComponent();
    this.updateShowCloseButton();
  }

  private projectComponent() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.modalComponent);
    this.container.clear();
    const componentRef = this.container.createComponent(
      componentFactory,
      null,
      Injector.create({
        providers: [
          {
            provide: MODAL_DATA,
            useValue: this.data.data,
          },
          {
            provide: NgbActiveModal,
            useValue: this.ngbActiveModal,
          },
        ],
      })
    );
    componentRef.changeDetectorRef.detectChanges();
  }

  public onClose(): void {
    this.ngbActiveModal.close();
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [BaseNotificationModalComponent],
  declarations: [BaseNotificationModalComponent],
  entryComponents: [BaseNotificationModalComponent],
})
export class BaseNotificationModalModule {}



// WEBPACK FOOTER //
// ./ts/app/shared/base-notification-modal/base-notification-modal.component.ts